import '../../styles/field.css';
import './BaseChip.css';
import './ChipKey.css';
export var key = '_13v0ule1-2-0-1';